import { useEditRestPolicies } from '../../redux/selectors/policies'
import { useBaseDrag } from '../common/useBaseDrag'
import { DND_TYPE } from '../constant'

type Params = {
  weeklyscheduleId: number
  restId: number
}

const useDragRest = ({ restId, weeklyscheduleId }: Params) => {
  const { canEditRest } = useEditRestPolicies({
    restId,
    weeklyscheduleId
  })

  const [collect, handleRef, previewRef] = useBaseDrag({
    type: DND_TYPE.REST,
    id: restId
  })

  if (!canEditRest) {
    return {
      handleRef: null,
      previewRef: null,
      collect: null,
      isDisabled: true
    }
  }

  return {
    handleRef,
    previewRef,
    collect,
    isDisabled: false
  }
}

export default useDragRest
